<template>
  <b-form-select v-model="localValue" :options="selectItems" :value-field="valueField"
                 :text-field="textField" :readonly="readonly" :disabled="readonly" :error-field="errorField" :class="[{'has-error': errorField in $root.errors}, groupClass]"></b-form-select>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'o-value-select-control',
    props: {
      value: {
        default: null
      },
      url: {
        type: String,
        default: ''
      },
      valueField: {
        type: String,
        default: 'value'
      },
      textField: {
        type: String,
        default: 'text'
      },
      items: {
        default: function () { return [] }
      },
      readonly: {
        type: Boolean,
        default: false
      },
      errorField: {
        type: String
      },
      groupClass: {
        type: String,
        default: ''
      }
    },

    mounted() {
      this.localValue = this.value
    },

    watch: {
      value(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.localValue = newVal
        }
      },
      localValue(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit('input', newVal)
          this.$emit('input-object', this.selectItems.find(i => i[this.valueField] == newVal))
        }
      }
    },

    created() {
      // no AJAX url specified, use options from property
      if (this.url === '') {
        this.selectItems = this.items
        return
      }

      axios
        .get(this.url, {params: {per_page: Number.MAX_SAFE_INTEGER}})
        .then((response) => {
          this.selectItems = response.data.data

          // if we already have a value, we might have set it before this request was finished
          // since the form using this component might be interested to have to full object,
          // we are emitting it right after loading
          if (this.localValue) {
            this.$emit('input-object', this.selectItems.find(i => i[this.valueField] == this.localValue))
          }
        })
        .catch((error) => {
          console.log(error)
          window.alert('could not fetch value list options from ' + this.url)
        })
    },

    data: () => ({
      selected: null,
      selectItems: [],
      localValue: ''
    })
  }
</script>
